require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-social-networking-site-starting-point.json") })
        }
      }, "path---post-social-networking-site-starting-point");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-social-networking-site-starting-point!./.cache/json/post-social-networking-site-starting-point.json
// module id = 354
// module chunks = 231608221292675